import {
  UPDATE_SHARE_LIST,
  RESET_SHARE_LIST,
  IShareHotelStoreState,
  ShareHotelActionTypes
} from './types';

const initialState: IShareHotelStoreState = {
  shareHotelsList: null
};

export default function shareHotelReducer(state = initialState, action: ShareHotelActionTypes) {
  switch (action.type) {
    case UPDATE_SHARE_LIST:
      const newData = action.actionData;
      const oldData = {...state.shareHotelsList};
      if (oldData[newData.hc]) {
        delete oldData[newData.hc];
      } else {
        oldData[newData.hc] = newData;
      }
      return {
        ...state,
        shareHotelsList: oldData,
      };

    case RESET_SHARE_LIST:
      return {
        ...state,
        shareHotelsList: null,
      };

    default:
      return state;
  }
}
